export default function getRootSectionValueObj(_id, values) {
  if (!values[_id]) return;

  if (values[_id].section === 'root' || !values[_id].section) {
    return { _id, ...values[_id] };
  } else {
    return getRootSectionValueObj(values[_id].section, values);
  }
};
